import { Text } from '@medly-components/core';
import { MenuExpandIcon, MenuHideIcon } from '@medly-components/icons';
import { FC } from 'react';

import NavItem from '../NavItem';
import { ToggleSwitchProps } from './types';

export const ToggleSwitch: FC<ToggleSwitchProps> = ({ isExpanded, onClick }) => (
    <NavItem onClick={onClick}>
        {isExpanded ? (
            <>
                <MenuHideIcon />
                <Text>Hide Menu</Text>
            </>
        ) : (
            <>
                <MenuExpandIcon />
                <Text>Open Menu</Text>
            </>
        )}
    </NavItem>
);
